import { ExpandLess, ExpandMore } from '@mui/icons-material'
import CasinoIcon from '@mui/icons-material/Casino'
import {
  Collapse,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
} from '@mui/material'
import { permissionValidation } from '@novafuturltd/shared'
import { useRouter } from 'next/router'
import { useContext, useState } from 'react'
import { useIntl } from 'react-intl'
import { TtoggleDrawerOnMobile } from '../../../containers/Sidebar/Sidebar'
import { useStyles } from '../../../containers/Sidebar/Sidebar.styles'
import { MixpanelContext } from '../../../contexts/mixpanel'
import { FeatureToggle } from '../../../contexts/toggle-feature'
import MenuGamePortfolio from '../game-portfolio/sidebar/MenuGamePortfolio'
import { MenuTenantGames } from '../tenant-games/sidebar/MenuTenantGames'
import { MenuProviderList } from './sub-menu/MenuProviderList'

interface GamesManagementSubMenuProps {
  hoverDrawer?: boolean
  openDrawer?: boolean
  permissions: string[]
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export const GamesManagementSubMenu = ({
  permissions,
  toggleDrawerOnMobile,
  openDrawer,
  hoverDrawer,
}: GamesManagementSubMenuProps) => {
  const { formatMessage } = useIntl()
  const { pathname } = useRouter()
  const classes = useStyles({ openDrawer, hoverDrawer })
  const [open, setOpen] = useState(pathname.includes('/casino'))
  const mxp = useContext(MixpanelContext)

  const adminPermission = permissionValidation(
    permissions,
    'games_management.*',
  )

  const hasProviderListPermission =
    adminPermission ||
    permissionValidation(permissions, 'games_management.provider.list')

  const hasTenantGamesPermission =
    adminPermission ||
    permissionValidation(permissions, 'games_management.tenant.games')

  const hasGamePortfolioPermission =
    adminPermission ||
    permissionValidation(permissions, 'games_management.games.portfolio')

  const gamesManagementPermission =
    hasProviderListPermission ||
    hasTenantGamesPermission ||
    hasGamePortfolioPermission

  const handleClick = () => {
    setOpen(!open)
    mxp.track('click', {
      element: 'games management menu click',
      section: 'sidebar',
    })
  }

  return gamesManagementPermission ? (
    <MenuList aria-labelledby="nested-list-subheader" className={classes.root}>
      <MenuItem className={classes.menuItem} onClick={handleClick}>
        <ListItemIcon>
          <CasinoIcon />
        </ListItemIcon>
        <ListItemText
          hidden={!openDrawer && !hoverDrawer}
          primary={formatMessage({
            id: 'casino.menu.management.title',
          })}
        />
        {open ? (
          <ExpandLess className={classes.expandIcon} />
        ) : (
          <ExpandMore className={classes.expandIcon} />
        )}
      </MenuItem>

      <Collapse
        in={open}
        timeout="auto"
        unmountOnExit
        hidden={!openDrawer && !hoverDrawer}
      >
        <MenuList component="div" disablePadding>
          <>
            {hasProviderListPermission && (
              <MenuProviderList
                pathname={pathname}
                toggleDrawerOnMobile={toggleDrawerOnMobile}
                nested={
                  openDrawer || hoverDrawer
                    ? classes.nested
                    : classes.nestedClosed
                }
              />
            )}
            {hasTenantGamesPermission && (
              <MenuTenantGames
                pathname={pathname}
                toggleDrawerOnMobile={toggleDrawerOnMobile}
                nested={
                  openDrawer || hoverDrawer
                    ? classes.nested
                    : classes.nestedClosed
                }
              />
            )}
            {hasGamePortfolioPermission && (
              <FeatureToggle.On name="casino:game-portfolio">
                <MenuGamePortfolio
                  pathname={pathname}
                  toggleDrawerOnMobile={toggleDrawerOnMobile}
                  nested={
                    openDrawer || hoverDrawer
                      ? classes.nested
                      : classes.nestedClosed
                  }
                />
              </FeatureToggle.On>
            )}
          </>
        </MenuList>
      </Collapse>
    </MenuList>
  ) : null
}
